import React, { memo } from 'react';
export const ForWhoSection = memo(function ForWhoSection() {
  const avatars = [{
    icon: '🏠',
    title: 'Estás harto de pagar de más por arreglos simples',
    desc: 'El técnico viene 20 minutos, te cobra una fortuna y vos sabés que podrías haberlo hecho vos mismo. Con el Megapack, la próxima vez lo resolvés solo.'
  }, {
    icon: '😰',
    title: 'Sabés que es fácil pero no te animás solo',
    desc: 'No querés arriesgarte a empeorar algo sin tener la información correcta. El Megapack te da el paso a paso exacto para actuar con seguridad.'
  }, {
    icon: '💡',
    title: 'Querés entender cómo funciona tu propia casa',
    desc: 'Por qué salta el diferencial, qué hacer cuando se va la luz, cómo leer tu tablero. Todo eso que siempre quisiste saber y nunca nadie te explicó.'
  }];
  return <section className="py-10 px-4 bg-gray-50 border-t border-gray-200" data-id="element-68">
      <div className="max-w-2xl mx-auto" data-id="element-69">
        {/* Header */}
        <h2 className="text-[22px] md:text-3xl font-black text-gray-900 text-center mb-6 leading-tight" data-id="element-70">
          Este Megapack <span className="text-blue-600" data-id="element-71">es para vos si...</span>
        </h2>

        {/* Lista compacta */}
        <div className="space-y-3" data-id="element-72">
          {avatars.map((avatar, index) => <div key={index} className="flex items-start gap-4 bg-white border border-gray-200 rounded-xl px-5 py-4 hover:border-blue-300 transition-colors shadow-sm" data-id="element-73">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-74">
                {avatar.icon}
              </span>
              <div data-id="element-75">
                <p className="text-gray-900 font-black text-[14px] md:text-base leading-snug" data-id="element-76">
                  {avatar.title}
                </p>
                <p className="text-gray-600 text-[12px] md:text-sm leading-relaxed mt-1" data-id="element-77">
                  {avatar.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
});